import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "All",
  dos_from: null,
  dos_to: null,
  microphoneVerifiedAt: localStorage.getItem("microphoneVerifiedAt")
    ? Number(localStorage.getItem("microphoneVerifiedAt"))
    : null,
};

const dictationSlice = createSlice({
  name: "dictation",
  initialState: initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setDosFrom: (state, action) => {
      state.dos_from = action.payload;
    },
    setDosTo: (state, action) => {
      state.dos_to = action.payload;
    },
    setMicrophoneVerified: (state, action) => {
      state.microphoneVerifiedAt = action.payload;

      if (action.payload) {
        localStorage.setItem("microphoneVerifiedAt", action.payload.toString());
      } else {
        localStorage.removeItem("microphoneVerifiedAt");
      }
    },
    resetDictation: () => {
      localStorage.removeItem("microphoneVerifiedAt");
      return initialState;
    },
  },
});

export const {
  setStatus,
  setDosFrom,
  setDosTo,
  setMicrophoneVerified,
  resetDictation,
} = dictationSlice.actions;

export default dictationSlice.reducer;
